import { LordIcon } from "@src/components/lord-icon/lord-icon";
import styles from "./icon.module.scss";

type Props = {
  src: string;
  isComingSoon?: boolean;
  isTitle?: boolean;
  size?: number;
};

export default function Icon(props: Props) {
  const { src, isComingSoon, isTitle, size=50 } = props;

  // Only one, or neither, of isComingSoon or isTitle should be true

  const defaultColor = "#274649";
  const comingSoonColor = "#A0A0A0";
  const titleColor = "#ffffff";

  var color = defaultColor;

  if (isComingSoon) {
    color = comingSoonColor;
  } else if (isTitle) {
    color = titleColor;
  }

  return (
    <div className={styles.lordiconContainer}>
      <LordIcon
        src={src}
        isHover={true}
        colors={{
          primary: color,
          secondary: color,
        }}
        size={size}
        target=".card_cardView__Go2OL"
      />
    </div>
  );
}
